import { Button, Pane, TextInputField } from 'evergreen-ui';
import { Formik } from 'formik';
import { Component } from 'react';

export default class ShortUrlForm extends Component {
    render() {
        return (
            <Formik initialValues={this.props.initialValues}
                enableReinitialize={true}
                validationSchema={this.props.validationSchema}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit = {(values) => {
                    this.props.onSave(values);
                }}
            >
                {({errors, handleChange, handleBlur, handleSubmit, setFieldValue, values}) => {
                    errors = Object.assign({}, this.props.errors, errors);

                    return <form>
                        <TextInputField
                            required
                            label="URL Original"
                            name="originalUrl"
                            description="URL-ul original care va fi redirectionat"
                            value={values.originalUrl || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            validationMessage={errors.name}/>

                        <TextInputField
                            label="Short Code"
                            name="shortCode"
                            description="Codul scurt pentru URL"
                            value={values.shortCode || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            validationMessage={errors.shortCode}/>

                        <Pane marginBottom={16}>
                            <Button
                                type="button"
                                onClick={() => {
                                    const randomCode = Math.random().toString(36).substring(2, 6);
                                    setFieldValue('shortCode', randomCode);
                                }}
                            >
                                Generate Random Code
                            </Button>
                        </Pane>


                        <Pane borderTop="default" marginTop={16} paddingTop={16}>
                            <Button type="submit" onClick={handleSubmit}>
                                Salveaza
                            </Button>
                        </Pane>
                    </form>
                }}
            </Formik>
        );
    }
}
